<template>
  <form>
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">{{isUpdate ? 'Update' : 'Add'}} Memry <span v-if="isDraft" style="color:orange;font-weight:bold;" >(DRAFT)</span></h4>
        <p class="category">Create and Edit your Memries here</p>
      </md-card-header>

      <md-card-content>
          <notifications></notifications>
        <div class="loader" v-if="!isready">
            <ring-loader :loading="true" color="orange" ></ring-loader>
        </div>
        <div class="md-layout" v-if="isready">
          <div class="md-layout-item md-small-size-100 md-size-100 reviewtoggle">
                <span class="pre-switch-lbl"><b>Review here</b></span>
               <md-switch v-model="isexternal" aria-label="External Review" @click="switchType()" class="md-primary">
                <b>Review externally</b>      
                </md-switch>
                <md-button class="md-just-icon md-simple md-primary md-xsmall">
                  <md-icon>help</md-icon>
                  <md-tooltip md-direction="top"><b>Choose Review externally if your main review will be on external material.</b><br/>However adding a short summary here is still recommended   </md-tooltip>
                </md-button>
        
            
          </div>
         
    		 <div class="md-layout-item md-small-size-100 md-size-100" style="margin-top:10px">
             <label>Start Date </label>
             <datepicker v-model="startdate" wrapper-class="datepickwrapper" input-class="datepickinput" :inline="false">
               </datepicker>
             <div v-if="isUpdate" style="font-style:italic;margin-top:4px;">Changing the start date on an active memry will reset the review cycle</div>
    		 </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Tags</label>
               <div>
                <vue-tags-input
                   v-model="tag"
                  :tags="tags"
                   :autocomplete-items="filteredItems"
                   :add-on-key="[13, ':', ';']"
                  @tags-changed="newTags => tags = newTags"
                  @before-adding-tag="processTag" 
                  
                  allow-edit-tags
                />
              </div>
              <span class="taginfo">Use a dash "-" to create Parent - Child tags. eg Favorites-Book-Chapter1</span>
                <md-button class="md-just-icon md-simple md-primary md-xsmall">
                  <md-icon>help</md-icon>
                  <md-tooltip md-direction="top"><b>Create relationship based tags and build a great Memry Tree</b><br/>This will help you properly structure and search through your summaries.</md-tooltip>
                </md-button>
            </md-field>
            
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>{{isexternal ? 'Source' : 'Question/Topic'}}</label>
              <md-input v-model="question" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100" v-if="!isexternal">
            <md-field>
              <label>Hint</label>
              <md-input v-model="hint" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
              
               <div class="editor">
                  <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                    <div class="menubar">

                      <button  type="button"
                        class="menubar__button"
                        :class="{ 'is-active': isActive.bold() }"
                        @click="commands.bold()"
                      >
                        
                        <md-icon class="md-icon-button">format_bold</md-icon>
                      </button>

                      <button  type="button"
                        class="menubar__button"
                        :class="{ 'is-active': isActive.italic() }"
                        @click="commands.italic()"
                      >
                        <md-icon class="md-icon-button">format_italic</md-icon>
                      </button>

                     <button  type="button"
                        class="menubar__button"
                        :class="{ 'is-active': isActive.underline() }"
                        @click="commands.underline()"
                      >
                        <md-icon class="md-icon-button">format_underline</md-icon>
                      </button>

                     
                      <!--
                        <button
                        class="menubar__button"
                        :class="{ 'is-active': isActive.paragraph() }"
                        @click="commands.paragraph"
                      >
                        <icon name="paragraph" />
                      </button>
                      -->
                      <button  type="button"
                        class="menubar__button mb-text"
                        :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                        @click="commands.heading({ level: 1 })"
                      >
                        H1
                      </button>

                      <button  type="button"
                        class="menubar__button  mb-text"
                        :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                        @click="commands.heading({ level: 2 })"
                      >
                        H2
                      </button>

                      <button  type="button"
                        class="menubar__button  mb-text"
                        :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                        @click="commands.heading({ level: 3 })"
                      >
                        H3
                      </button>

                      <button  type="button"
                        class="menubar__button"
                        :class="{ 'is-active': isActive.bullet_list() }"
                        @click="commands.bullet_list()"
                      >
                         <md-icon class="md-icon-button">format_list_bulleted</md-icon>
                      </button>

                      <button  type="button"
                        class="menubar__button"
                        :class="{ 'is-active': isActive.ordered_list() }"
                        @click="commands.ordered_list()"
                      >
                        <md-icon class="">format_list_numbered</md-icon>
                      </button>

                      <button  type="button"
                        class="menubar__button"
                        :class="{ 'is-active': isActive.blockquote() }"
                        @click="commands.blockquote()"
                      >
                        <md-icon class="md-icon-button">format_quote</md-icon>
                      </button>

                     
                       <button  type="button"
                        class="menubar__button mb-text"
                        @click="commands.horizontal_rule()"
                      >
                        ___
                      </button>

                      <button  type="button"
                        class="menubar__button"
                        @click="commands.undo()"
                      >
                        <md-icon class="md-icon-button">undo</md-icon>
                      </button>

                      <button  type="button"
                        class="menubar__button" 
                        @click="commands.redo()"
                      >
                        <md-icon class="md-icon-button">redo</md-icon>
                      </button>

                    </div>
                  </editor-menu-bar>

                  <editor-content class="editor__content" :editor="editor" />
                </div>
           
          </div>
          
          <div class="md-layout-item md-size-100 text-right">
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button  class="md-raised md-info" style="float:left;" @click="newMemry()">New</md-button>
             <div class="" v-if="processing" style="float:left;">
                <ring-loader :loading="true" color="orange" ></ring-loader>
              </div>
            <md-button  :disabled="processing" class="md-raised md-warning" @click="update(true)">Save as Draft</md-button>
            <md-button  :disabled="processing" class="md-raised md-success" @click="update(false)">{{isUpdate ? (isDraft ? 'Activate' : 'Update') : 'Add'}}</md-button>
            
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  HorizontalRule,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'

import VueTagsInput from '@johmun/vue-tags-input';
import ApiService from "@/services/api.service";
import Datepicker from 'vuejs-datepicker';
import UtilService from "@/services/util.service";
import moment from "moment";
import _ from "lodash";
import {RingLoader} from '@saeris/vue-spinners'


export default {
  name: "edit-memry-form",
   components: {
     EditorMenuBar,
    EditorContent,
    VueTagsInput,
    Datepicker,
    RingLoader
  },
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      question: null,
      answer: null,
      hint: null,
      isexternal: false,
      useSelectedDate: false,
      updatememry: {},
      isUpdate: false,
      isDraft: false,
      tags: [],
      tag: '',
      startdate: null,
      autocompleteItems: [],
      alltags: [],
      tabProcessing: false,   
      isready: false, 
      processing: false, 
      notifytype: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new HorizontalRule(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: '<p>Enter your <b>Answer or Summary</b> here.<br/>Format your <b>text</b> to keep it <i>clear</i> and concise.</p>Paste links to external resources like <a href="http://www.dafyomi.co.il">www.dafyomi.co.il</a>'
        })
      }
  },
  computed: {
      filteredItems() {
      return this.autocompleteItems.filter(i => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
  },
   mounted() {
       this.startdate = moment().toDate();
      
       console.log(this.$props,this.$route.params, this.startdate);
      //load tags
        ApiService.getTags()
        .then(response => { 
           
           
            if(!response || response.data == null) {
              this.alltags = [];
            } else {
               console.log('tags',response.data);
               this.alltags = response.data;
               if(!this.alltags || this.alltags.constructor !== Array)
                    this.alltags = [];
               
               this.autocompleteItems = this.alltags.map(a => {
                    return { text: a.path };
                  });
               

               
            }

            var alltags = this.alltags;

              if(this.$route.params != null && this.$route.params.id != null) {

                  ApiService.getMemry(this.$route.params.id).then(response => { 

                      if(!response || !response.data) {
                        this.notifyVue('Could not find memry',false)
                        return;
                      }

                      var extend = UtilService.extendMemries([response.data],alltags);
                      if(extend.drafts.length > 0)
                        this.updatememry =  extend.drafts[0];
                      else
                        this.updatememry =  extend.memries[0];
                      this.isUpdate = true;
                      this.question = this.updatememry.question;
                      this.hint = this.updatememry.hint;
                      this.startdate = this.updatememry.datecreated;
                      this.isexternal = this.updatememry.type == 1;
                      console.log('Setting startdate: ',this.startdate);
                      this.editor.setContent(this.updatememry.answer);
                    
                      
                      _.each(this.updatememry.tagpaths, (path) => {
                          this.tags.push({text: path});
                      })

                        this.isDraft = this.updatememry.active == 0;
                        this.isready = true;
                  });
                  
              } else {
                this.isready = true;
              }
              
        });

     

      
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  methods: {
    
    refreshAutoComplete() {
         this.autocompleteItems = this.alltags.map(a => {
          return { text: a.path };
        });
    },
    newMemry() {
          this.question = '';
          this.hint = '';
          this.editor.clearContent();
          this.isUpdate = false;
          this.updatememry = null;
          this.startdate = new Date();
    },
    update(deactivate = false) {
     
    
      var answer = this.editor.getHTML();

      if(!deactivate) {
        if(this.tags == null || this.tags.length == 0) {
          this.notifyVue("Please add at least one tag/category.",false);
          return;
        } 
        
        if(!this.question || this.question == "") {
          this.notifyVue("Please specify a question.",false);
          return;
        }
      
       //console.log('Get Content',answer);
        if(this.answer == "") {
          this.notifyVue("Please specify an answer.",false);
          return;
        }
      }

        this.processing = true;
      var addtags = [];
       _.each(this.tags,(tag) => {
          let findtag = _.find(this.alltags,{'path':tag.text});
          if(findtag)
              addtags.push(findtag.id);
       });

      var newmemry = {};
     

      if(this.updatememry != null && this.updatememry.id != null) {
        newmemry = this.updatememry;
        
      }
      newmemry.active = deactivate ? 0 : 1;
      newmemry.question = this.question;
      newmemry.hint = this.hint;
      newmemry.answer = answer;
      newmemry.type = this.isexternal ? 1: 0;
       newmemry.datecreated = moment(this.startdate).format("YYYY-MM-DD");
      //newmemry.datecreated = moment(newmemry.datecreated).toDate();

      //console.log('Add Memry',newmemry);
      
       newmemry.tags = JSON.stringify(addtags);
        ApiService.createMemry(newmemry).then((resp) => {
          
          if(this.isUpdate) {
            var resetmsg = resp.data && resp.data.reset ? ' and the cycle has been reset' : '';

            this.notifyVue("Your Memry has been updated" + resetmsg + '!',true)

            this.isDraft = newmemry.active == 0;
          } else {
            this.question = '';
            this.hint = '';
            this.editor.clearContent();

            this.notifyVue("Well done! A new Memry was created. Go for it, create another one!",true)
          }
            this.processing = false;

        }, (err) => {
            this.processing = false;
             this.notifyVue("Something went wrong! Maybe try again? ",false)
          console.error('Create Failed',err);
      });
    },

     notifyVue(msg, success) {
      var color = success ? 'info' : 'warning';
      this.$notify({
        message: msg,
        icon: "add_alert",
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: color
      });
    },

    processTag(tagobj) {
     
        
       
        var newtag = tagobj.tag.text;
                              
        console.log("Processing",this.tabProcessing,tagobj);

        this.tabProcessing = false;
        if(newtag.indexOf('--') >= 0) {
          newtag = newtag.replace('--','-');
          
        }

        if(newtag.indexOf('- ') >= 0 || newtag.indexOf(' -') >= 0) {
          newtag = newtag.replace('- ','-');
          newtag = newtag.replace(' -','-');
          
        }

        //foreach tag/subtag separated by dashes either create a tag unless already exists
        var newtagarr = newtag.split('-');
        var ptid = -1;
        var ptpath = "";
        var count = 0;
        var applyTag = false;
        var _self = this;
        _.each(newtagarr,(nt) => {
            
            
            count++;
            if(count == newtagarr.length)
              applyTag = true;

            var ptag = _.find(_self.alltags,{'path': ptpath + nt});
            if(ptag == null) {
              //createtag
              ptag = { "name": nt,  "path": ptpath + nt, "parentid": ptid};
                ApiService.createTag(ptag).then((resp) => {
                  var ctag = resp.data;

                  _self.alltags.push(ctag);
                  _self.refreshAutoComplete();
                  
                 
                  if(applyTag) 
                    _self.updateTag(tagobj);
                  else   //recursively call again
                    _self.processTag(tagobj)

                  
                
              }, (err) => {
                  console.error('Tags Failed',err);
                  _self.notifyVue("Failed building tags! Try again",false)
              });
              return false; //will call this method again recursively above
            } else {
              //exists so just build path and parentid
              ptid = ptag.id;
              ptpath = ptag.path + '-';
               if(applyTag)
                    _self.updateTag(tagobj);
            }
        })
    
    },
    updateTag(tagobj) {
      if(tagobj.addTag)
        tagobj.addTag();
      else
        tagobj.saveTag();
    }
  
  }

  
};
</script>
<style></style>
